/* 4Star Boutiqueen — theme scripts */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initNavToggle();
    initDrawers();
    initHeroSlideshow();
    initQuantitySelectors();
    initAddToCartForms();
    initNewsletterForms();
    initWishlist();
  });

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function initNavToggle() {
    var toggle = qs("[data-nav-toggle]");
    var nav = qs("[data-site-nav]");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
    qsa("[data-nav-close]", nav).forEach(function (btn) {
      btn.addEventListener("click", function () {
        nav.classList.remove("is-open");
      });
    });
    /* Tapping anywhere outside the open mobile menu (or the hamburger
     * itself) closes it -- otherwise the only way out on a phone is
     * finding the close button. */
    document.addEventListener("click", function (e) {
      if (!nav.classList.contains("is-open")) return;
      if (nav.contains(e.target) || toggle.contains(e.target)) return;
      nav.classList.remove("is-open");
    });
  }

  function initDrawers() {
    qsa("[data-open-drawer]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = qs(btn.getAttribute("data-open-drawer"));
        if (target) target.classList.add("is-open");
      });
    });
    qsa("[data-close-drawer]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var parent = btn.closest(".overlay-drawer");
        if (parent) parent.classList.remove("is-open");
      });
    });
    qsa(".overlay-drawer").forEach(function (drawer) {
      drawer.addEventListener("click", function (e) {
        if (e.target === drawer) drawer.classList.remove("is-open");
      });
    });
  }

  function initHeroSlideshow() {
    var hero = qs("[data-hero-slideshow]");
    if (!hero) return;
    var slides = qsa("[data-hero-slide]", hero);
    var dots = qsa("[data-hero-dot]", hero);
    if (slides.length < 2) return;
    var index = 0;
    function show(i) {
      slides.forEach(function (s, idx) { s.style.display = idx === i ? "" : "none"; });
      dots.forEach(function (d, idx) { d.classList.toggle("is-active", idx === i); });
      index = i;
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { show(i); });
    });
    show(0);
    setInterval(function () { show((index + 1) % slides.length); }, 5000);
  }

  function initQuantitySelectors() {
    qsa("[data-qty-selector]").forEach(function (wrap) {
      var input = qs("input", wrap);
      qsa("button", wrap).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = parseInt(btn.getAttribute("data-step"), 10);
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          var max = input.getAttribute("max");
          if (max && val > parseInt(max, 10)) val = parseInt(max, 10);
          input.value = val;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  function updateCartCount(count) {
    qsa("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";
    });
  }

  function initAddToCartForms() {
    qsa("[data-add-to-cart-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        /* a "Buy it Now" button (name="checkout") should navigate straight to
         * checkout via a normal form submission, not be intercepted by the
         * AJAX add-to-cart flow below */
        var submitter = e.submitter;
        if (submitter && submitter.name === "checkout") return;

        e.preventDefault();
        var btn = qs("button[type=submit]:not([name=checkout])", form);
        if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = "Adding..."; }
        var formData = new FormData(form);
        fetch("/cart/add.js", { method: "POST", body: formData, headers: { Accept: "application/json" } })
          .then(function (r) {
            if (!r.ok) { return r.json().then(function (err) { throw err; }); }
            return r.json();
          })
          .then(function () {
            /* Go straight to the cart page after a successful add, rather
             * than opening the cart drawer or leaving the shopper on the
             * product/collection page. */
            var cartUrl = (document.body && document.body.dataset.cartUrl) || "/cart";
            window.location.href = cartUrl;
          })
          .catch(function (err) {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText; }
            var message = (err && err.description) || "Sorry, this item could not be added to your cart.";
            alert(message);
          });
      });
    });
  }

  function initNewsletterForms() {
    qsa("[data-newsletter-form]").forEach(function (form) {
      form.addEventListener("submit", function () {
        var note = qs("[data-newsletter-note]", form.parentElement);
        if (note) note.textContent = "Thank you for subscribing!";
      });
    });
  }

  /* ---------------- Wishlist ---------------- */
  var WISHLIST_KEY = "boutiqueen_wishlist";

  function getWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function isWished(id) {
    return getWishlist().some(function (item) { return String(item.id) === String(id); });
  }

  function toggleWish(data) {
    var list = getWishlist();
    var idx = -1;
    list.forEach(function (item, i) { if (String(item.id) === String(data.id)) idx = i; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(data);
    }
    setWishlist(list);
    renderWishlistUI();
  }

  function escapeHtml(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderWishlistUI() {
    var list = getWishlist();

    qsa("[data-wishlist-count]").forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length > 0 ? "" : "none";
    });

    qsa("[data-wishlist-toggle]").forEach(function (btn) {
      var id = btn.getAttribute("data-product-id");
      btn.classList.toggle("is-active", isWished(id));
    });

    var container = qs("[data-wishlist-items]");
    var emptyMsg = qs("[data-wishlist-empty]");
    if (!container) return;

    if (list.length === 0) {
      container.innerHTML = "";
      if (emptyMsg) emptyMsg.style.display = "";
      return;
    }
    if (emptyMsg) emptyMsg.style.display = "none";

    container.innerHTML = list.map(function (item) {
      var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : "";
      return (
        '<div class="wishlist-item">' +
          img +
          '<div class="wishlist-item__info">' +
            '<a href="' + escapeHtml(item.url) + '" class="wishlist-item__title">' + escapeHtml(item.title) + "</a>" +
            '<div class="wishlist-item__price">' + escapeHtml(item.price) + "</div>" +
          "</div>" +
          '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + escapeHtml(item.id) + '" aria-label="Remove from wishlist">&times;</button>' +
        "</div>"
      );
    }).join("");
  }

  function initWishlist() {
    renderWishlistUI();

    document.addEventListener("click", function (e) {
      var toggleBtn = e.target.closest("[data-wishlist-toggle]");
      if (toggleBtn) {
        e.preventDefault();
        toggleWish({
          id: toggleBtn.getAttribute("data-product-id"),
          handle: toggleBtn.getAttribute("data-product-handle"),
          title: toggleBtn.getAttribute("data-product-title"),
          price: toggleBtn.getAttribute("data-product-price"),
          image: toggleBtn.getAttribute("data-product-image"),
          url: toggleBtn.getAttribute("data-product-url")
        });
        return;
      }

      var removeBtn = e.target.closest("[data-wishlist-remove]");
      if (removeBtn) {
        e.preventDefault();
        var id = removeBtn.getAttribute("data-wishlist-remove");
        var list = getWishlist().filter(function (item) { return String(item.id) !== String(id); });
        setWishlist(list);
        renderWishlistUI();
      }
    });
  }
})();
